<template>
    <div v-if="variant === 'default'" class="StatsBlockItem flex flex-col items-center">
        <div class="flex w-full flex-col items-center">
            <CHeading class="mb-2 text-center text-2xl [font-family:var(--font-family-heading)] sm:text-3xl" tag="p" variant="1">
                <slot name="heading" />
            </CHeading>
            <div
                class="relative max-w-[164px] whitespace-normal text-center text-sm sm:text-base md:max-w-none md:whitespace-nowrap"
            >
                <slot name="text" />
            </div>
            <div class="flex w-full flex-col text-center">
                <template v-for="(link, index) in links">
                    <a
                        v-if="link.href"
                        :key="'a-' + index"
                        class="mt-1 inline-block text-sm text-primary-910 dark:text-primary-300 underline"
                        :href="link.href"
                    >
                        {{ link.text }}
                    </a>
                    <NuxtLink
                        v-else-if="link.to"
                        :key="'nuxt-' + index"
                        class="mt-1 inline-block text-sm text-primary-910 dark:text-primary-300 underline"
                        :to="link.to"
                    >
                        {{ link.text }}
                    </NuxtLink>
                </template>
            </div>
        </div>
    </div>

    <div
        v-else-if="variant === 'B2B'"
        class="StatsBlockItem mt-4 flex w-32 flex-row justify-center sm:ml-10 md:mt-0 xl:ml-14"
    >
        <div>
            <CHeading class="mb-0 text-center text-2xl [font-family:var(--font-family-heading)] sm:text-left sm:text-3xl" tag="p" variant="1">
                <slot name="heading" />
            </CHeading>
            <div class="relative text-center text-sm sm:text-left sm:text-base" variant="muted">
                <slot name="text" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CHeading from '@/components/ui/CHeading.vue'

interface Props {
    variant?: string
    links?: Array<{
        text: string
        to?: string | { name: string }
        href?: string
    }>
}

const props = withDefaults(defineProps<Props>(), {
    variant: 'default',
    links: () => []
})
</script>